export enum EnumIdDest {
    INTERNA = 1,
    INTERESTADUAL = 2,
    EXTERIOR = 3
}